export const Constants = {
  EMPTY_ROWS_AFTER_PRODUCTS: 3,
  DATE_FORMAT_OPTIONS: {
    FORMAT: {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    },
    LOCALE: 'en-GB',
  },
  FONT: {
    TIMES_NEW_ROMAN: 'Times New Roman',
    SIZE: 12,
    LINK_COLOR: 'FF0000FF',
  },
  ROW_CONTENT: {
    EMPTY: '',
  },
  TRANSLATION_KEYS: {
    PRODUCT_RANGE: 'filters.product_range',
    PRODUCT_NAME: 'product_name',
    CLASS: 'class',
    APIR: 'apir',
    PERFORMANCE: {
      INCEPTION_DATE: 'excel_report.inception_date',
      YTD: 'excel_report.ytd',
      ONE_YEAR: 'excel_report.one_year',
      THREE_YEAR: 'excel_report.three_years_annualised',
      FIVE_YEAR: 'excel_report.five_years_annualised',
      TEN_YEAR: 'excel_report.ten_years_annualised',
      SINCE_INCEPTION: 'excel_report.since_inception',
    },
    PRICE: {
      NAV_PRICE: 'tables.price.headers.nav_price',
      APPLICATION_PRICE: 'tables.price.headers.application_price',
      WITHDRAWAL_PRICE: 'tables.price.headers.withdrawal_price',
      PRICE_AS_OF: 'tables.price.headers.price_as_of',
    },
    ROW_CONTENT: {
      ROW_2: 'excel_report.product_explorer',
      ROW_5: 'heading.showing_products',
      ROW_8_CUMULATIVE: 'performance_tile_title',
      ROW_9_PERFORMANCE: 'excel_report.performance_as_of_date',
      ROW_9_CUMULATIVE: 'excel_report.cumulative_as_of_date',
      BENCHMARK_NAME: 'excel_report.benchmark_name',
    },
    FILE_NAME: {
      DEFAULT: 'excel_report.file_name.default',
      PERFORMANCE: 'excel_report.file_name.performance',
      PRICE: 'excel_report.file_name.price',
      CUMULATIVE_PERFORMANCE: 'excel_report.file_name.cumulative',
    },
  },
  ALIGNMENT: {
    VERTICAL: {
      BOTTOM: 'bottom',
    },
    HORIZONTAL: {
      LEFT: 'left',
      RIGHT: 'right',
    },
  },
  CELL_FORMAT: {
    NUMBER: '0.00',
    CURRENCY: '"$"#,##0.00',
  },
  HTML_TAGS: {
    PARAGRAPH: {
      OPEN: '<p>',
      CLOSE: '</p>',
    },
    DIV: {
      OPEN: 'div',
    },
    B: 'b',
    I: 'i',
    EM: 'em',
    A: 'a',
    STRONG: 'strong',
  },
  COLUMN_WIDTHS: {
    PERFORMANCE: {
      COLUMN_A: 31,
      COLUMN_B: 43,
      COLUMN_C: 10,
      COLUMN_D: 13,
      COLUMN_E: 16,
      COLUMN_F: 11,
      COLUMN_G: 20,
      COLUMN_H: 12,
      COLUMN_I: 12,
      COLUMN_J: 12,
      COLUMN_K: 16,
    },
    PRICE: {
      COLUMN_A: 31,
      COLUMN_B: 43,
      COLUMN_C: 10,
      COLUMN_D: 13,
      COLUMN_E: 20,
      COLUMN_F: 25,
      COLUMN_G: 26,
      COLUMN_H: 16,
    },
    CUMULATIVE: {
      COLUMN_A: 31,
      COLUMN_B: 43,
      COLUMN_C: 10,
      COLUMN_D: 13,
      COLUMN_E: 16,
      COLUMN_F: 16,
    },
  },
  EXCEL_MIME_TYPE:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  EXCEL_FILE_EXTENSION: 'xlsx',
  EMPTY: '',
  HYPHEN: '-',
  TYPE_OF: {
    NUMBER: 'number',
  },
} as const;
